module.exports = __webpack_public_path__ + "static/media/Volkswagen_logo_text.71c85887.svg";